import {
  changeCampaign,
  fetchCampaignLineCreatives,
  toggleDelayReasonVisibility,
} from '../../campaign-editor/actions';
import { connectEditor } from '../../campaign-editor/connect-editor';
import { campaignLineStatuses } from '../../campaign-editor/constants';
import { calculateBillableBudget } from '../../utils/billable-field-helpers';
import getEventTargetValue from '../../utils/get-event-target-value';
import ProjectCampaignEditor from './ProjectCampaignEditor';

const mapStateToProps = ({ campaign, campaignUI, campaignLinesById }) => ({
  model: campaign,
  isChangeRequestAllowed: Object.values(campaignLinesById).some(line =>
    [
      campaignLineStatuses.READY,
      campaignLineStatuses.PUSHED,
      campaignLineStatuses.LOCKED,
    ].includes(line.status),
  ),
  billableBudgets: calculateBillableBudget({
    campaign,
    campaignLinesById,
  }),
  isDelayReasonVisible: campaignUI && campaignUI.isDelayReasonVisible,
});

const mapDispatchToProps = dispatch => ({
  onChange: event =>
    dispatch(
      changeCampaign(event.target.name, getEventTargetValue(event.target)),
    ),
  refreshCampaignLineCreatives: () => dispatch(fetchCampaignLineCreatives()),
  changeDelayReasonVisibility: visible =>
    dispatch(toggleDelayReasonVisibility(visible)),
});

export default connectEditor(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectCampaignEditor);
